import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dimmer, Loader } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';

const ResetInternalUserPasswordForm = props => {
  const { resetPasswordModal, resettingUserPassword } = props;

  return (
    <>
      <Dimmer active={resettingUserPassword}>
        <Loader size="massive">Resetting Password...</Loader>
      </Dimmer>
      <SemanticToastContainer />
      <p>
        The password for user{' '}
        <strong>{resetPasswordModal.selectedUser.email}</strong> will be reset
        to the default password. Please inform the user to change their password
        on the next login. <br /> <br />
        Do you want to continue?
      </p>
    </>
  );
};

const mapStateToProps = ({ access }) => ({
  resetPasswordModal: access.resetPasswordModal,
  resettingUserPassword: access.resettingUserPassword,
});

ResetInternalUserPasswordForm.propTypes = {
  resetPasswordModal: PropTypes.object.isRequired,
  resettingUserPassword: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ResetInternalUserPasswordForm);
